var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 168,
    viewBox: "0 0 248 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 248,
    height: 174.449,
    fill: "#111213"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22.6299,
    y: 53.749,
    width: 76.3802,
    height: 14.1445,
    rx: 7.07224,
    fill: "url(#paint0_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22.4404,
    y: 53.9385,
    width: 76.0013,
    height: 13.7656,
    rx: 6.88279,
    stroke: "url(#paint1_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.8008,
    y: 75.4375,
    width: 64.1217,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint2_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.6113,
    y: 75.627,
    width: 63.7428,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint3_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.8008,
    y: 90.5244,
    width: 36.7757,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint4_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.6113,
    y: 90.7139,
    width: 36.3968,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint5_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.8008,
    y: 105.612,
    width: 53.7491,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint6_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.6113,
    y: 105.802,
    width: 53.3701,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint7_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.7803,
    y: 75.4375,
    width: 33.0038,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint8_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9697,
    y: 75.627,
    width: 32.6249,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint9_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter5_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.7803,
    y: 90.5254,
    width: 46.2053,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint10_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9697,
    y: 90.7148,
    width: 45.8264,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint11_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.7803,
    y: 105.612,
    width: 36.7757,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint12_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9697,
    y: 105.802,
    width: 36.3968,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint13_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter7_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.7803,
    y: 120.7,
    width: 27.346,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint14_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.9697,
    y: 120.89,
    width: 26.9671,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint15_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter8_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.306,
    y: 120.7,
    width: 62.2357,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint16_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.495,
    y: 120.889,
    width: 61.8568,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint17_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter9_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38.6602,
    y: 120.7,
    width: 62.2357,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint18_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38.4707,
    y: 120.889,
    width: 61.8568,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint19_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.362,
    y: 75.4375,
    width: 46.2053,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint20_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.552,
    y: 75.627,
    width: 45.8264,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint21_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter11_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.362,
    y: 90.5254,
    width: 30.1749,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint22_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.552,
    y: 90.7148,
    width: 29.796,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint23_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.362,
    y: 105.612,
    width: 46.2053,
    height: 7.54373,
    rx: 3.77186,
    fill: "url(#paint24_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.552,
    y: 105.802,
    width: 45.8264,
    height: 7.16482,
    rx: 3.58241,
    stroke: "url(#paint25_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.0664,
    y: 53.749,
    width: 76.3802,
    height: 14.1445,
    rx: 7.07224,
    fill: "url(#paint26_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2559,
    y: 53.9385,
    width: 76.0013,
    height: 13.7656,
    rx: 6.88279,
    stroke: "url(#paint27_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_bd_12461_210059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.705,
    y: 53.749,
    width: 76.3802,
    height: 14.1445,
    rx: 7.07224,
    fill: "url(#paint28_linear_12461_210059)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.895,
    y: 53.9385,
    width: 76.0013,
    height: 13.7656,
    rx: 6.88279,
    stroke: "url(#paint29_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_d_12461_210059)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59.5977,
    y1: 53.7495,
    x2: 59.5977,
    y2: 112.213,
    stroke: "url(#paint30_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_d_12461_210059)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 149.18,
    y1: 53.749,
    x2: 149.18,
    y2: 112.213,
    stroke: "url(#paint31_linear_12461_210059)",
    strokeWidth: 0.378904,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.5629,
    cy: 55.1634,
    r: 10.8441,
    fill: "url(#paint32_linear_12461_210059)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4909 54.2205C41.7394 53.7628 48.3527 53.5544 50.4487 54.6924C52.5447 55.8304 54.5174 61.2925 53.7494 62.707C53.5009 63.1647 50.6588 57.7162 48.5628 56.5782C46.4668 55.4402 37.2483 54.2206 41.4909 54.2205Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3701 54.1554C46.5221 53.8755 48.6767 53.6606 49.8399 54.2921C51.0031 54.9237 51.7429 57.0391 51.5909 57.319C51.4389 57.599 50.4342 55.793 49.271 55.1614C48.1077 54.5298 46.2182 54.4354 46.3701 54.1554Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136.26,
    cy: 55.1639,
    r: 10.8441,
    fill: "url(#paint33_linear_12461_210059)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.188 54.221C129.437 53.7633 136.05 53.5549 138.146 54.6929C140.242 55.8309 142.215 61.293 141.447 62.7075C141.198 63.1651 138.356 57.7167 136.26 56.5787C134.164 55.4407 124.946 54.2211 129.188 54.221Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.067 54.1559C134.219 53.876 136.374 53.661 137.537 54.2926C138.7 54.9242 139.44 57.0396 139.288 57.3195C139.136 57.5995 138.131 55.7934 136.968 55.1619C135.805 54.5303 133.915 54.4359 134.067 54.1559Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 224.9,
    cy: 55.1634,
    r: 10.8441,
    fill: "url(#paint34_linear_12461_210059)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.828 54.221C218.076 53.7633 224.69 53.5549 226.786 54.6929C228.882 55.8309 230.854 61.293 230.086 62.7075C229.838 63.1651 226.996 57.7167 224.9 56.5787C222.804 55.4407 213.585 54.2211 217.828 54.221Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_12461_210059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.707 54.1559C222.859 53.876 225.014 53.661 226.177 54.2926C227.34 54.9242 228.08 57.0396 227.928 57.3195C227.776 57.5995 226.771 55.7934 225.608 55.1619C224.445 54.5303 222.555 54.4359 222.707 54.1559Z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_12461_210059",
    x: -25.2822,
    y: 51.0967,
    width: 81.6845,
    height: 19.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_12461_210059",
    x: -22.4531,
    y: 72.7852,
    width: 69.4267,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_12461_210059",
    x: -22.4531,
    y: 87.8721,
    width: 42.0801,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_12461_210059",
    x: -22.4531,
    y: 102.96,
    width: 59.0537,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_12461_210059",
    x: 67.1279,
    y: 72.7852,
    width: 38.3086,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bd_12461_210059",
    x: 67.1279,
    y: 87.8731,
    width: 51.5097,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bd_12461_210059",
    x: 67.1279,
    y: 102.96,
    width: 42.0801,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bd_12461_210059",
    x: 67.1279,
    y: 118.048,
    width: 32.6504,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bd_12461_210059",
    x: 157.653,
    y: 118.047,
    width: 67.54,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bd_12461_210059",
    x: -41.3125,
    y: 118.047,
    width: 67.54,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_bd_12461_210059",
    x: 156.71,
    y: 72.7852,
    width: 51.5097,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_bd_12461_210059",
    x: 156.71,
    y: 87.8731,
    width: 35.4795,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_bd_12461_210059",
    x: 156.71,
    y: 102.96,
    width: 51.5097,
    height: 13.2275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bd_12461_210059",
    x: 62.4141,
    y: 51.0967,
    width: 81.6845,
    height: 19.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_bd_12461_210059",
    x: 151.053,
    y: 51.0967,
    width: 81.6845,
    height: 19.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.32616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12461_210059"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.51562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757809
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12461_210059",
    result: "effect2_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_12461_210059",
    x: 58.4652,
    y: 51.8636,
    width: 4.15077,
    height: 62.2357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.942966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_12461_210059",
    x: 148.047,
    y: 51.8631,
    width: 4.15077,
    height: 62.2357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.942966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_210059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_210059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_12461_210059",
    x: 9.42978,
    y: 16.0304,
    width: 78.2664,
    height: 78.2659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_12461_210059",
    x: 34.7299,
    y: 48.1962,
    width: 24.8468,
    height: 20.196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_12461_210059",
    x: 44.4754,
    y: 51.9954,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_12461_210059",
    x: 97.127,
    y: 16.0308,
    width: 78.2664,
    height: 78.2659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_12461_210059",
    x: 122.427,
    y: 48.1967,
    width: 24.8468,
    height: 20.196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_12461_210059",
    x: 132.173,
    y: 51.9959,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_12461_210059",
    x: 185.767,
    y: 16.0304,
    width: 78.2664,
    height: 78.2659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1445,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_12461_210059",
    x: 211.067,
    y: 48.1967,
    width: 24.8468,
    height: 20.196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8289,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_12461_210059",
    x: 220.812,
    y: 51.9959,
    width: 9.02089,
    height: 7.23866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.942966,
    result: "effect1_foregroundBlur_12461_210059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12461_210059",
    x1: 7.57223,
    y1: 67.8935,
    x2: 21.2889,
    y2: 34.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12461_210059",
    x1: -16.7545,
    y1: 67.2235,
    x2: 26.6798,
    y2: 26.2026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12461_210059",
    x1: 5.55408,
    y1: 82.9812,
    x2: 10.6345,
    y2: 63.3936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12461_210059",
    x1: -14.8683,
    y1: 82.6239,
    x2: 6.62287,
    y2: 50.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12461_210059",
    x1: -5.25902,
    y1: 98.0681,
    x2: 2.58985,
    y2: 80.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12461_210059",
    x1: -16.9719,
    y1: 97.7108,
    x2: 5.93909,
    y2: 78.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12461_210059",
    x1: 1.45256,
    y1: 113.156,
    x2: 7.35594,
    y2: 94.0773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12461_210059",
    x1: -15.6662,
    y1: 112.799,
    x2: 6.98596,
    y2: 84.5711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12461_210059",
    x1: 82.8306,
    y1: 82.9812,
    x2: 91.2318,
    y2: 66.3094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12461_210059",
    x1: 72.319,
    y1: 82.6239,
    x2: 94.7148,
    y2: 65.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12461_210059",
    x1: 88.0507,
    y1: 98.0691,
    x2: 94.7123,
    y2: 79.5615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12461_210059",
    x1: 73.3345,
    y1: 97.7118,
    x2: 96.4825,
    y2: 72.9148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12461_210059",
    x1: 84.322,
    y1: 113.156,
    x2: 92.1709,
    y2: 95.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12461_210059",
    x1: 72.6092,
    y1: 112.799,
    x2: 95.5201,
    y2: 93.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12461_210059",
    x1: 80.5934,
    y1: 128.244,
    x2: 89.8746,
    y2: 112.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12461_210059",
    x1: 71.8838,
    y1: 127.887,
    x2: 92.8696,
    y2: 114.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12461_210059",
    x1: 184.915,
    y1: 128.243,
    x2: 190.129,
    y2: 108.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12461_210059",
    x1: 165.093,
    y1: 127.886,
    x2: 186.819,
    y2: 96.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12461_210059",
    x1: -14.051,
    y1: 128.243,
    x2: -8.83687,
    y2: 108.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12461_210059",
    x1: -33.8728,
    y1: 127.886,
    x2: -12.1467,
    y2: 96.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12461_210059",
    x1: 177.633,
    y1: 82.9812,
    x2: 184.294,
    y2: 64.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12461_210059",
    x1: 162.917,
    y1: 82.6239,
    x2: 186.065,
    y2: 57.8269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12461_210059",
    x1: 171.294,
    y1: 98.0691,
    x2: 180.132,
    y2: 82.0346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12461_210059",
    x1: 161.683,
    y1: 97.7118,
    x2: 183.48,
    y2: 82.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12461_210059",
    x1: 177.633,
    y1: 113.156,
    x2: 184.294,
    y2: 94.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12461_210059",
    x1: 162.917,
    y1: 112.799,
    x2: 186.065,
    y2: 88.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12461_210059",
    x1: 95.2685,
    y1: 67.8935,
    x2: 108.985,
    y2: 34.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0.0936458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12461_210059",
    x1: 70.9418,
    y1: 67.2235,
    x2: 117.449,
    y2: 28.7158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12461_210059",
    x1: 183.907,
    y1: 67.8935,
    x2: 197.624,
    y2: 34.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12461_210059",
    x1: 159.58,
    y1: 67.2235,
    x2: 203.015,
    y2: 26.2026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12461_210059",
    x1: 58.4556,
    y1: 58.2467,
    x2: 64.5488,
    y2: 58.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_12461_210059",
    x1: 148.038,
    y1: 58.2462,
    x2: 154.131,
    y2: 58.8422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12461_210059",
    x1: 49.0343,
    y1: 55.1634,
    x2: 48.5629,
    y2: 74.4942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12461_210059",
    x1: 136.732,
    y1: 55.1639,
    x2: 136.26,
    y2: 74.4947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_12461_210059",
    x1: 225.371,
    y1: 55.1634,
    x2: 224.9,
    y2: 74.4942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12461_210059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 168,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceInsight);
export default __webpack_public_path__ + "static/media/performance-insight.682c94257b566cc4341647875bfa637b.svg";
export { ForwardRef as ReactComponent };